import React from 'react';
// MUI removed - using Tailwind + lucide
  function TopBanner({title, history, icon }) {
	const goHome = (event) => {
		history.push("/landing")
	}

	return (
        <div className="w-full bg-[#880e4f] text-white px-3 py-2 flex items-center gap-2">
			<button onClick={goHome} className="p-1">←</button>
			<div className="flex-1 font-semibold">{title}</div>
			{icon && <img 
			  src={icon} 
			  alt="icon" 
			  className="h-8 w-auto max-w-[40px]" 
			  style={{ height: '32px', width: 'auto', maxWidth: '40px' }} 
			/>}
		</div>
    );
}

export default TopBanner

